import React from "react"
import { companyData } from "./data"

const DefaultBusinessMeta = () => {
  return (
    <>
      <meta
        property="business:contact_data:street_address"
        content={companyData.address.street}
      />
      <meta
        property="business:contact_data:locality"
        content={companyData.address.locality}
      />
      <meta
        property="business:contact_data:region"
        content={companyData.address.region}
      />
      <meta
        property="business:contact_data:postal_code"
        content={companyData.address.postalCode}
      />
      <meta
        property="business:contact_data:country_name"
        content={companyData.address.country}
      />
    </>
  )
}

export default DefaultBusinessMeta
